import { ReportConfiguration } from "../../../configuration"
import { DocumentSection } from "../../types";
import { formatTitle } from "../../utils";
import * as ReactDOM from "react-dom"
import { getHtmlToPowerPointBaseOptions } from "../../pptx-configuration/slides";
import ExpensesComparaisonTable, { ChapterRow } from "./expense-operation-comparaison-table";
import * as React from "react"
import * as Model from "../../../../../model"
import * as ComparaisonDomain from "../../../../../domain/sfp/comparaison-domain"
import PptxGenJS, { Slide, TableRow } from "pptxgenjs"
import { Scenario } from "../../../../../model";
import InvestPrevRealCompareTable from "./invest-prev-real-compare-table";
import { ScenarioContext, findAccountValue, getOperationAccounts } from "../../scenario-context";



export function checkComparaisonSection(
    configuration: ReportConfiguration
): boolean {
    const comparaison = configuration.observation.comparaison;
    return comparaison.tables || comparaison.blankTable;
}

export async function createComparaisonSection(
    pptx: PptxGenJS,
    configuration: ReportConfiguration,
    numbering: number[],
    years: number[],
    localAuthority: Model.LocalAuthority,
    scenario: Scenario,
    scenarioContext: ScenarioContext
): Promise<DocumentSection> {
    const title = formatTitle("Comparaisons", numbering);
    const slides: Slide[] = [];
    const comparaison = configuration.observation.comparaison;
    const currentYear = configuration.generalities.referenceYear

    const chapterValuesRecettes: ChapterRow[] = ComparaisonDomain.GetChapterList(localAuthority.accounts, true, false);
    const chapterValuesDepenses: ChapterRow[] = ComparaisonDomain.GetChapterList(localAuthority.accounts, true, true);

    // Prévisions N : montant du chapitre dans la Synthèse du scénarii de fonctionnement
    const prevAmountFinder = (receipts: boolean) => (chapterNumber: string): number =>
        getOperationAccounts(scenarioContext, receipts)
            .filter(laca => laca.chapter && laca.chapter.number == chapterNumber)
            .reduce((total, laca) => total + (findAccountValue(scenarioContext, laca, receipts, currentYear) || 0), 0)

    chapterValuesDepenses.forEach(o => {
        const lib = ComparaisonDomain.GetChapterLibelle(o, localAuthority);
        o.chapitreLibelle = lib == undefined ? "" : lib.chapter.label;
        o.values = ComparaisonDomain.GetChapterValues(o, localAuthority, currentYear, prevAmountFinder(false), false);
    })
    chapterValuesDepenses.sort(function (chapter1, chapter2) {
        if (chapter1 && !chapter2) return -1
        if (!chapter1 && chapter2) return 1
        if (!chapter1 && !chapter2) return 0
        if (chapter1.chapitreNumber === chapter2.chapitreNumber) return 0
        return chapter1.chapitreNumber > chapter2.chapitreNumber ? 1 : -1
    });
    chapterValuesDepenses.push({
        values: ComparaisonDomain.computeTotal(chapterValuesDepenses),
        chapitreNumber: "",
        chapitreLibelle: "TOTAL DES DEPENSES DE FONCTIONNEMENT"
    })
    chapterValuesRecettes.forEach(o => {
        const lib = ComparaisonDomain.GetChapterLibelle(o, localAuthority);
        o.chapitreLibelle = lib == undefined ? "" : lib.chapter.label;
        o.values = ComparaisonDomain.GetChapterValues(o, localAuthority, currentYear, prevAmountFinder(true), true);
    })
    chapterValuesRecettes.sort(function (chapter1, chapter2) {
        if (chapter1 && !chapter2) return -1
        if (!chapter1 && chapter2) return 1
        if (!chapter1 && !chapter2) return 0
        if (chapter1.chapitreNumber === chapter2.chapitreNumber) return 0
        return chapter1.chapitreNumber > chapter2.chapitreNumber ? 1 : -1
    });
    chapterValuesRecettes.push({
        values: ComparaisonDomain.computeTotal(chapterValuesRecettes),
        chapitreNumber: "",
        chapitreLibelle: "TOTAL DES RECETTES DE FONCTIONNEMENT"
    })

    const InvestRecettesChapterList: ChapterRow[] = ComparaisonDomain.GetChapterList(localAuthority.accounts, false, false);
    const InvestDepensesChapterList: ChapterRow[] = ComparaisonDomain.GetChapterList(localAuthority.accounts, false, true);

    InvestRecettesChapterList.forEach(o => {
        const lib = ComparaisonDomain.GetChapterLibelle(o, localAuthority);
        o.chapitreLibelle = lib == undefined ? "" : lib.chapter.label;
    })
    InvestRecettesChapterList.sort(function (chapter1, chapter2) {
        if (chapter1 && !chapter2) return -1
        if (!chapter1 && chapter2) return 1
        if (!chapter1 && !chapter2) return 0
        if (chapter1.chapitreNumber === chapter2.chapitreNumber) return 0
        return chapter1.chapitreNumber > chapter2.chapitreNumber ? 1 : -1
    });

    InvestDepensesChapterList.forEach(o => {
        const lib = ComparaisonDomain.GetChapterLibelle(o, localAuthority);
        o.chapitreLibelle = lib == undefined ? "" : lib.chapter.label;
    })
    InvestDepensesChapterList.sort(function (a, b) {
        var textA = a.chapitreLibelle.toUpperCase();
        var textB = b.chapitreLibelle.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
    if (comparaison.tables) {
        const tableId = "management-report-retrospective-comparaison-receipt-expenses"
        const tempDiv = document.createElement("div")
        document.head.appendChild(tempDiv)

        const table = <ExpensesComparaisonTable
            expenceTableDatas={chapterValuesDepenses}
            currentYear={currentYear}
            currency={configuration.currency}
            id={tableId}
            locale={configuration.locale}
            roundness={configuration.generalities.roundness}
            enableHideZeroLines={configuration.generalities.enableHideZeroLines}
            tableConfiguration={configuration.table}
            years={years} />

        ReactDOM.render(table, tempDiv, () => {
            let options = getHtmlToPowerPointBaseOptions(title + " des dépenses de fonctionnement")
            pptx.addSlidesForTable(tableId, options)
            document.head.removeChild(tempDiv)
        })

        const tempDivExpenses = document.createElement("div")
        document.head.appendChild(tempDivExpenses)

        const tableExpenses = <ExpensesComparaisonTable
            expenceTableDatas={chapterValuesRecettes}
            currency={configuration.currency}
            currentYear={currentYear}
            id={tableId}
            locale={configuration.locale}
            roundness={configuration.generalities.roundness}
            enableHideZeroLines={configuration.generalities.enableHideZeroLines}
            tableConfiguration={configuration.table}
            years={years} />

        ReactDOM.render(tableExpenses, tempDivExpenses, () => {
            let options = getHtmlToPowerPointBaseOptions(title + " des recettes de fonctionnement")
            pptx.addSlidesForTable(tableId, options)
            document.head.removeChild(tempDivExpenses)
        })
    }

    if (comparaison.blankTable) {
        const tempDivInvestExpenses = document.createElement("div")
        document.head.appendChild(tempDivInvestExpenses)
        const tableId = "management-report-invest-expense-compare"
        const tableInvestExpenses = <InvestPrevRealCompareTable
            expenceTableDatas={InvestDepensesChapterList}
            currency={configuration.currency}
            currentYear={currentYear}
            isReceipt={false}
            id={tableId}
            locale={configuration.locale}
            roundness={configuration.generalities.roundness}
            enableHideZeroLines={false}
            tableConfiguration={configuration.table}
            years={years} />

        ReactDOM.render(tableInvestExpenses, tempDivInvestExpenses, () => {
            let options = getHtmlToPowerPointBaseOptions(title + " sur l'investissement : Dépenses")
            options.x = 2.8;
            pptx.addSlidesForTable(tableId, options)
            document.head.removeChild(tempDivInvestExpenses)
        })

        const tempDivInvestReceipt = document.createElement("div")
        document.head.appendChild(tempDivInvestReceipt)
        const tableIdReceipt = "management-report-invest-expense-compare"
        const tableInvestReceipt = <InvestPrevRealCompareTable
            expenceTableDatas={InvestRecettesChapterList}
            currency={configuration.currency}
            currentYear={currentYear}
            isReceipt={true}
            id={tableIdReceipt}
            locale={configuration.locale}
            roundness={configuration.generalities.roundness}
            enableHideZeroLines={false}
            tableConfiguration={configuration.table}
            years={years} />

        ReactDOM.render(tableInvestReceipt, tempDivInvestReceipt, () => {
            const options = getHtmlToPowerPointBaseOptions(title + " sur l'investissement : Recettes")
            options.x = 2.8;
            pptx.addSlidesForTable(tableIdReceipt, options)
            document.head.removeChild(tempDivInvestReceipt)
        })
    }

    return { title, slides }
}


// WEBPACK FOOTER //
// ./src/component/management-report/generator/observation-generator/comparaison-generator/index.tsx